module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_9005.3b887969.png";